/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Moment from "moment";
import CurrencyInput from "react-currency-input-field";
import PhoneInputWithCountrySelect, {
  isValidPhoneNumber,
} from "react-phone-number-input";
import DatePicker, { registerLocale } from "react-datepicker";
import Navbar from "../core/components/NavBar";
import UserContext from "../core/UserContext";
import CustomNumberInput from "../core/components/custom-number-input/CustomNumberInput";
import {
  getUserDataFromLocalStorage,
  isValidAgeNextBirthdayWithTerm,
  isValidNic,
  getDate_ddmmyyyy,
} from "../core/utils";

import useAxiosPrivate from "../hooks/useAxiosPrivate";
import useUserData from "../hooks/useUserData";
import "react-datepicker/dist/react-datepicker.css";
import uk from "date-fns/locale/en-GB";
import GoBack from "../core/components/goBack";
import apiRoutes from "../api/apiRoutes";
import { BiChevronDown } from "react-icons/bi";
import { IoCheckmark } from "react-icons/io5";
import { PlusIcon } from "lucide-react";
import { toast } from "react-toastify";
registerLocale("uk", uk);

const FlexiSingleQuotationAuthenticated = () => {
  // eslint-disable-next-line no-unused-vars
  const { userData, setUserData } = useContext(UserContext);
  const userDataStorage = getUserDataFromLocalStorage();
  const axiosPrivate = useAxiosPrivate(userDataStorage);
  const localUserData = useUserData();
  const navigate = useNavigate();
  const whatsappNumberRef = useRef();
  const bankRepContactRef = useRef();
  const jointLifephoneNumberRef = useRef();
  const phoneNumberRef = useRef();
  const [bankBranches, setBankBranches] = useState([]);
  const [pepQuestions, setPepQuestions] = useState([]);
  const [fatcaQuestions, setFatcaQuestions] = useState([]);
  const [pepQuestionsJoint, setPepQuestionsJoint] = useState([]);
  const [fatcaQuestionsJoint, setFatcaQuestionsJoint] = useState([]);
  const [state, setState] = useState({
    title: "",
    firstname: "",
    lastname: "",
    email: "",
    phoneNumber: "",
    birth: "",
    nic: "",
    maiden_name: "",
    passport_number: "",
    nationality: "",
    beneficiaries: [
      {
        fullname: "",
        percentage: "",
        nic: "",
        relationship: "",
      },
    ],
    joint_user_title: "",
    joint_user_firstname: "",
    joint_user_lastname: "",
    joint_user_birth: null,
    joint_user_nic: "",
    joint_user_email: "",
    joint_user_phoneNumber: "",
    joint_user_maiden_name: "",
    joint_user_passport_number: "",
    joint_user_nationality: "",
    joint_user_relationship: "",
    intended_commencement_date: new Date(Moment().format("YYYY-MM-DD")),
    join_loan: false,
    term_number: "",
    initial_sum_assured: "",
    term_option: "years",
    gender: "",
    loan_type: "capital-interest",
    loan_plan: "",
    payment_insurance_plan: "monthly",
    with_refund: false,
    with_tpd: true,
    bank_name: "",
    bank_branch_name: "",
    joint_user_financial_institution_branch: "",
    bank_rep_name: "",
    bank_rep_email: "",
    bank_rep_contact: "",
    consent_bank_rep: false,
  });

  const dropdownRef = useRef(null);
  const intendedCommencementDateRef = useRef();
  const birthRef = useRef();
  const otherBirthRef = useRef();
  const [banks, setBanks] = useState([]);
  const [jointLifeFieldsDisabled, setJointLifeFieldsDisabled] = useState(true);
  const eighteenYearsAgo = Moment().subtract(18, "years").format("YYYY-MM-DD");
  const sixtyFiveYearsAgo = Moment().subtract(65, "years").format("YYYY-MM-DD");
  const fifteenDaysFromToday = Moment().add(15, "days").format("YYYY-MM-DD");
  const today = Moment().format("YYYY-MM-DD");
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState();
  const [search, setSearch] = useState("");
  const [openAgent, setOpenAgents] = useState(false);
  const [filterSearch, setFilterSearch] = useState([]);
  const [errors, setErrors] = useState({
    title: null,
    name: null,
    firstname: null,
    lastname: null,
    email: null,
    nic: null,
    phoneNumber: null,
    birth: null,
    maiden_name: null,
    passport_number: null,
    nationality: null,
    joint_user_title: null,
    joint_user_name: null,
    joint_user_firstname: null,
    joint_user_lastname: null,
    joint_user_email: null,
    joint_user_gender: null,
    joint_user_nic: null,
    joint_user_maiden_name: null,
    joint_user_passport_number: null,
    joint_user_nationality: null,
    joint_user_relationship: null,
    term_number: null,
    gender: null,
    initial_sum_assured: null,
    term_option: null,
    loan_type: null,
    loan_plan: null,
    payment_insurance_plan: null,
  });

  const showErrorsForInput = (errs) => {
    if (errs && Array.isArray(errs)) {
      errs.forEach((err) => {
        toast.error(err);
      });
    } else if (errs) {
      toast.error(errs);
    }
  };

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // const [quotationResult, setQuotationResult] = useState(null);
  const [validatingJointLife, setValidatingJointLife] = useState(false);

  useEffect(() => {
    setState({ ...state, whatsappNumber: state.phoneNumber });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.phoneNumber]);

  const getDeclarationQuestions = async () => {
    const url = "/declaration/active";

    try {
      const response = await axiosPrivate.post(url, { active: true });

      setPepQuestions(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "PEP"),
      );
      setPepQuestionsJoint(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "PEP"),
      );
      setFatcaQuestions(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "FATCA"),
      );
      setFatcaQuestionsJoint(
        response.data.data
          .map((item) => {
            item.isAccepted = null;
            return item;
          })
          .filter((item) => item.type === "FATCA"),
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getBanks();
    getDeclarationQuestions();
  }, []);

  useEffect(() => {
    setJointLifeFieldsDisabled(!state.join_loan);
  }, [state.join_loan]);

  const getBanks = async () => {
    const url = process.env.REACT_APP_API_URL + `/bank`;

    const response = await axiosPrivate.get(url);

    if (response.data.success) {
      setBanks(response.data.data);
    }
  };
  const validateJointLife = async () => {
    if (
      !state.joint_user_phoneNumber ||
      !isValidPhoneNumber(state.joint_user_phoneNumber)
    ) {
      setError("Please enter valid phone number for joint life");
      return;
    }

    setValidatingJointLife(true);

    setError(null);

    const url = `/user/check-phone/${state.joint_user_phoneNumber}`;

    try {
      const response = await axiosPrivate.get(url);
      if (response.data.success) {
        const jointLifeData = response.data.data;
        const title = jointLifeData?.title ? jointLifeData?.title : "";
        const name = jointLifeData?.name ? jointLifeData?.name : "";
        // const firstname = name.includes(" ") ? name.split(" ")[0] : "";
        // const lastname = name.includes(" ") ? name.split(" ")[1] : "";

        const firstname = name.includes(" ")
          ? name.split(" ").slice(0, -1).join(" ")
          : "";
        const lastname = name.includes(" ")
          ? name.split(" ").slice(-1).join(" ")
          : "";

        const birth = jointLifeData?.birth
          ? new Date(Moment(jointLifeData?.birth).format("YYYY-MM-DD"))
          : null;
        const email = jointLifeData?.email ? jointLifeData?.email : "";
        const nic = jointLifeData?.nic ? jointLifeData?.nic : "";
        const gender = jointLifeData?.gender ? jointLifeData?.gender : "";
        const whatsappNumber = jointLifeData?.whatsappNumber
          ? jointLifeData?.whatsappNumber
          : null;

        setState({
          ...state,
          joint_user_firstname: firstname,
          joint_user_lastname: lastname,
          joint_user_nic: nic,
          joint_user_birth: birth,
          joint_user_email: email,
          joint_user_title: title,
          joint_user_gender: gender,
          joint_user_whatsappNumber: whatsappNumber,
          userJointId: jointLifeData?.id,
          joint_user_maiden_name: jointLifeData?.maidenName,
          joint_user_passport_number: jointLifeData?.passportNumber,
          joint_user_nationality: jointLifeData?.nationality,
          joint_user_relationship: jointLifeData?.relationship,
        });
      } else {
        // setJointLifeFieldsDisabled(false);
        setState({ ...state, userJointId: null });
      }
      setJointLifeFieldsDisabled(false);

      setValidatingJointLife(false);
      console.log(response);
    } catch (err) {
      setJointLifeFieldsDisabled(false);
      console.log(err);
      setValidatingJointLife(false);
    }
  };

  const getBranchesForBank = (bank) => {
    if (banks.length === 0) {
      return [];
    }
    const filteredBanks = banks.filter((item) => {
      return bank === item.name;
    });

    if (!filteredBanks || filteredBanks.length === 0) {
      return [];
    }

    const selectedBank = filteredBanks[0];
    if (!selectedBank.BranchBanks) {
      return [];
    }

    return selectedBank.BranchBanks;
  };

  const [beneficiaries, setBeneficiaries] = useState([
    { fullname: "", percentage: "", nic: "", relationship: "" },
  ]);

  const [beneficiaryErrors, setBeneficiaryErrors] = useState([{}]);

  const totalAllocated = beneficiaries.reduce(
    (sum, beneficiary) => sum + (parseFloat(beneficiary.percentage) || 0),
    0,
  );

  const addBeneficiary = () => {
    if (totalAllocated < 100 && beneficiaries.length < 100) {
      const remainingPercentage = 100 - totalAllocated;
      setBeneficiaries([
        ...beneficiaries,
        {
          fullname: "",
          percentage: remainingPercentage.toString(),
          nic: "",
          relationship: "",
        },
      ]);
      setBeneficiaryErrors([...beneficiaryErrors, {}]);

      // When adding a beneficiary, ensure bank section is disabled
      setActiveBenefit(0);
    }
  };

  const removeBeneficiary = (index) => {
    if (beneficiaries.length > 1) {
      const newBeneficiaries = [...beneficiaries];
      newBeneficiaries.splice(index, 1);
      setBeneficiaries(newBeneficiaries);

      const newErrors = [...beneficiaryErrors];
      newErrors.splice(index, 1);
      setBeneficiaryErrors(newErrors);
    } else {
      setBeneficiaries([
        {
          fullname: "",
          percentage: "",
          nic: "",
          relationship: "",
        },
      ]);
      setBeneficiaryErrors([{}]);
    }
  };

  const handlePercentageChange = (index, value) => {
    const newPercentage = parseFloat(value) || 0;
    const currentPercentage = parseFloat(beneficiaries[index].percentage) || 0;
    const difference = newPercentage - currentPercentage;

    const remainingPercentage = 100 - (totalAllocated + difference);

    if (remainingPercentage >= 0) {
      const newBeneficiaries = [...beneficiaries];
      newBeneficiaries[index].percentage = value;
      setBeneficiaries(newBeneficiaries);
    } else {
      const newBeneficiaries = [...beneficiaries];
      newBeneficiaries[index].percentage = (
        parseFloat(beneficiaries[index].percentage) + remainingPercentage
      ).toString();
      setBeneficiaries(newBeneficiaries);
    }

    validateBeneficiaries();
  };

  // handle beneficiary changes
  const handleBeneficiaryChange = (index, field, value) => {
    const newBeneficiaries = [...beneficiaries];
    newBeneficiaries[index][field] = value;
    setBeneficiaries(newBeneficiaries);

    if (field === "percentage") {
      handlePercentageChange(index, value);
    } else {
      validateBeneficiaries();
    }
  };

  // Validate beneficiaries
  const validateBeneficiaries = () => {
    const newErrors = beneficiaries.map((beneficiary, i) => {
      const errors = {};

      // Check for duplicate NICs
      const nicCount = beneficiaries.filter(
        (b, idx) => b.nic === beneficiary.nic && b.nic !== "" && idx !== i,
      ).length;
      if (nicCount > 0) {
        errors.nic = "Duplicate NIC not allowed";
      }

      // Check percentage is valid number
      const percentage = parseFloat(beneficiary.percentage);
      if (percentage && isNaN(percentage)) {
        errors.percentage = "Invalid percentage";
      } else if (percentage <= 0) {
        errors.percentage = "Percentage must be greater than 0";
      } else if (percentage > 100) {
        errors.percentage = "Cannot exceed 100%";
      }

      // Check fullname is provided if percentage is > 0
      if (percentage > 0 && !beneficiary.fullname.trim()) {
        errors.fullname = "Full name required";
      }

      return errors;
    });

    setBeneficiaryErrors(newErrors);
    return newErrors.every((err) => Object.keys(err).length === 0);
  };

  const clearBankDetails = () => {
    setState((prev) => ({
      ...prev,
      initial_sum_assured: "",
      bank_name: "",
      bank_branch: "",
      joint_user_financial_institution_branch: "",
      bank_rep_name: "",
      bank_rep_email: "",
      bank_rep_contact: "",
    }));
    setErrors((prev) => ({
      ...prev,
      initial_sum_assured: null,
      bank_name: null,
      bank_branch: null,
    }));
  };

  const submitData = async () => {
    setErrors({
      title: null,
      name: null,
      firstname: null,
      lastname: null,
      email: null,
      nic: null,
      phoneNumber: null,
      birth: null,
      maiden_name: null,
      passport_number: null,
      nationality: null,
      joint_user_title: null,
      joint_user_name: null,
      joint_user_firstname: null,
      joint_user_lastname: null,
      joint_user_email: null,
      joint_user_gender: null,
      joint_user_nic: null,
      joint_user_maiden_name: null,
      joint_user_passport_number: null,
      joint_user_nationality: null,
      joint_user_relationship: null,
      term_number: null,
      gender: null,
      initial_sum_assured: null,
      term_option: null,
      loan_type: null,
      bank_name: null,
      bank_branch_name: null,
      loan_plan: null,
      payment_insurance_plan: null,
    });

    const hasBeneficiaries = beneficiaries.some(
      (b) => b.fullname && parseFloat(b.percentage) > 0,
    );
    const hasBankDetails = state.bank_name && state.bank_branch_name;

    if (hasBeneficiaries && hasBankDetails) {
      setError(
        "Please provide either Beneficiary details OR Bank details, not both",
      );
      return;
    }

    if (activeBenefit === 1) {
      if (!state.initial_sum_assured) {
        setErrors((prev) => ({
          ...prev,
          initial_sum_assured: ["Sum Assured is required"],
        }));
        return;
      }
      if (!state.bank_name) {
        setErrors((prev) => ({
          ...prev,
          bank_name: ["Financial Institution is required"],
        }));
        showErrorsForInput(["Financial Institution is required"]);
        return;
      }
      if (!state.bank_branch_name) {
        setErrors((prev) => ({
          ...prev,
          bank_branch_name: ["Branch is required"],
        }));
        showErrorsForInput(["Branch is required"]);
        return;
      }
    }

    if (activeBenefit === 0) {
      const isBeneficiariesValid = validateBeneficiaries();

      if (!isBeneficiariesValid) {
        setError("Please correct beneficiary information");
        return;
      }

      if (beneficiaries.some((b) => b.fullname) && totalAllocated !== 100) {
        setError("Total beneficiary allocation must be 100%");
        return;
      }

      if (
        beneficiaries.some((b) => {
          return b.relationship.trim().length === 0 || !b.relationship;
        })
      ) {
        setError("Relationship is required for all beneficiaries");
        return;
      }
    }

    if (state.title.trim().length === 0 || !state.title) {
      setErrors({ title: ["title is required"] });
      showErrorsForInput(["title is required"]);
      return;
    }

    if (state.firstname.trim().length === 0 || !state.firstname) {
      setErrors({ firstname: ["first names is required"] });
      showErrorsForInput(["first names is required"]);
      return;
    }

    if (state.lastname.trim().length === 0 || !state.lastname) {
      setErrors({ lastname: ["last name is required"] });
      showErrorsForInput(["last name is required"]);
      return;
    }

    if (
      !state.birth ||
      (typeof state.birth === "string" && state.birth.trim().length === 0)
    ) {
      setErrors({ birth: ["birthday is required"] });
      showErrorsForInput(["birthday is required"]);
      return;
    }

    if (state.email.trim().length === 0 || !state.email) {
      setErrors({ email: ["Email is required"] });
      showErrorsForInput(["Email is required"]);
      return;
    }

    //implement validation for passport_number
    if (
      !state.nationality ||
      (typeof state.nationality === "string" &&
        state.nationality.trim().length === 0)
    ) {
      setErrors({ nationality: ["Nationality is required"] });
      showErrorsForInput(["Nationality is required"]);
      return;
    }

    // NEW VALIDATIONS

    if (
      !state.nic ||
      (typeof state.nic === "string" && state.nic.trim().length === 0)
    ) {
      setErrors({ nic: ["NIC is required"] });
      showErrorsForInput(["NIC is required"]);
      return;
    }

    if (state.nic.length === 0 || state.nic.length !== 14) {
      setErrors({ nic: ["The NIC number must be 14 characters"] });
      showErrorsForInput(["The NIC number must be 14 characters"]);
      return;
    }

    if (!state.gender) {
      setErrors({ gender: ["gender is required"] });
      showErrorsForInput(["gender is required"]);
      return;
    }

    if (!state.join_loan) {
      const url = apiRoutes.createFlexiQuotation;

      //Term+ageNextBirthday Validation
      if (!isValidAgeNextBirthdayWithTerm(state.birth, state.term_number)) {
        setError(
          "Sum of age next birthday and term should not be more than 75!",
        );
        return;
      }

      if (state.nic.length === 0 || state.nic.length !== 14) {
        setErrors("The NIC number must be 14 characters");
        return;
      }

      if (!isValidNic(state.nic, state.birth)) {
        setError("The NIC number doesn't match with the birthday");
        return;
      }

      try {
        setLoading(true);
        toast.error(null);
        const payload = {
          ...state,
          userId: null,
          userJointId: null,
          main_user_title: state.title,
          main_user_name: state.firstname + " " + state.lastname,
          main_user_birth: getDate_ddmmyyyy(state.birth),
          main_user_nic: state.nic,
          main_user_gender: state.gender,
          main_user_maiden_name: state.maiden_name,
          main_user_phoneNumber: state.phoneNumber,
          main_user_whatsappNumber: state.whatsappNumber,
          main_user_email: state.email,
          main_user_passport_number: state.passport_number,
          main_user_nationality: state.nationality,
          savings_type: "regular",
          payment_insurance_plan: "monthly",
          initial_sum_assured: state.initial_sum_assured || 100000,
          basic_contribution_amount: 1000,
          single_contribution_amount: 50000,
          intended_commencement_date: getDate_ddmmyyyy(
            state.intended_commencement_date,
          ),
          branch_name: state.bank_branch_name,
          bank_branch_name: state.bank_branch_name,
          bank_rep_email: state.bank_rep_email,
          consent_bank_rep: true,
          death_benefit: 100000,
          tpd_benefit: 100000,
          beneficiaries: beneficiaries
            .filter((b) => b.fullname && parseFloat(b.percentage) > 0)
            .map((b) => ({
              fullname: b.fullname,
              percentage: parseFloat(b.percentage),
              nic: b.nic,
              relationship: b.relationship,
            })),
        };

        delete payload.firstname;
        delete payload.lastname;
        delete payload.joint_user_title;
        delete payload.joint_user_firstname;
        delete payload.joint_user_lastname;
        delete payload.joint_user_birth;
        delete payload.joint_user_nic;
        delete payload.joint_user_email;
        delete payload.joint_user_phoneNumber;
        delete payload.joint_user_maiden_name;
        delete payload.joint_user_passport_number;
        delete payload.joint_user_nationality;
        delete payload.joint_user_relationship;

        // PROVISIONAL FIX
        // return console.log({payload});

        if (payload.bank_branch_name === "Other") {
          payload.bank_branch_name =
            payload.joint_user_financial_institution_branch;
          delete payload.joint_user_financial_institution_branch;
        }

        try {
          payload.initial_sum_assured = parseFloat(
            payload.initial_sum_assured.toString(),
          );
        } catch (error) {
          console.log(error);
        }

        if (selectedAgent) {
          payload.workerId = selectedAgent;
        }

        setLoading(true);
        const { data } = await axiosPrivate.post(url, payload);

        setLoading(false);
        setErrors({
          title: null,
          name: null,
          firstname: null,
          lastname: null,
          email: null,
          nic: null,
          phoneNumber: null,
          birth: null,
          maiden_name: null,
          passport_number: null,
          nationality: null,
          joint_user_title: null,
          joint_user_name: null,
          joint_user_firstname: null,
          joint_user_lastname: null,
          joint_user_email: null,
          joint_user_nic: null,
          joint_user_maiden_name: null,
          joint_user_passport_number: null,
          joint_user_nationality: null,
          joint_user_relationship: null,
          term_number: null,
          gender: null,
          initial_sum_assured: null,
          term_option: null,
          loan_type: null,
          loan_plan: null,
          bank_branch_name: null,
          payment_insurance_plan: null,
        });
        if (data.success) {
          //show quotation
          if (data.success) {
            navigate(
              `${process.env.REACT_APP_BASENAME}/quotations/${data.data.flexibleResult.id}`,
            );
          }
        } else {
          toast.error(
            data.message
              ? data.message
              : "Quotation generation was unsuccessful, please try again",
          );
        }
      } catch (error) {
        //Handing Form Errors
        setLoading(false);
        toast.error(null);

        if (
          error?.response?.data?.errors &&
          Object.keys(error?.response?.data?.errors).length > 0
        ) {
          const errorsFromServer = error.response.data.errors;
          console.error(errorsFromServer);
          let errorData = {};
          if (Array.isArray(errorsFromServer)) {
            errorsFromServer.forEach((err) => {
              if (!errorData[err.field]) {
                errorData[err.field] = [];
              }
              errorData[err.field].push(err.message);
            });
          }
          setErrors(errorData);
        } else if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          toast.error(
            "Quotation generation was unsuccessful, please try again",
          );
        }
      }
    } else {
      const url =
        process.env.REACT_APP_API_URL + apiRoutes.createFlexiQuotation;
      try {
        // Extra Frontend Validation
        if (
          state.joint_user_title.trim().length === 0 ||
          !state.joint_user_title
        ) {
          setErrors({ joint_user_title: ["title is required"] });
          showErrorsForInput(["title for joint life is required"]);
          return;
        }

        if (
          state.joint_user_firstname.trim().length === 0 ||
          !state.joint_user_firstname
        ) {
          setErrors({ joint_user_firstname: ["first names is required"] });
          showErrorsForInput(["first names for joint life is required"]);
          return;
        }

        if (
          state.joint_user_lastname.trim().length === 0 ||
          !state.joint_user_lastname
        ) {
          setErrors({ joint_user_lastname: ["last name is required"] });
          showErrorsForInput(["last name for joint life is required"]);
          return;
        }

        if (
          !state.joint_user_birth ||
          (typeof state.joint_user_birth === "string" &&
            state.joint_user_birth.trim().length === 0)
        ) {
          setErrors({ joint_user_birth: ["birthday is required"] });
          showErrorsForInput(["birthday for joint life is required"]);
          return;
        }

        if (
          !state.joint_user_gender ||
          (typeof state.joint_user_gender === "string" &&
            state.joint_user_gender.trim().length === 0)
        ) {
          setErrors({ joint_user_gender: ["Gender is required"] });
          showErrorsForInput(["Gender for joint life is required"]);
          return;
        }
        if (
          !state.joint_user_nic ||
          (typeof state.joint_user_nic === "string" &&
            state.joint_user_nic.trim().length === 0)
        ) {
          setErrors({ joint_user_nic: ["NIC is required"] });
          showErrorsForInput(["NIC for joint life is required"]);
          return;
        }

        if (
          state.joint_user_nic.length === 0 ||
          state.joint_user_nic.length !== 14
        ) {
          setErrors({
            joint_user_nic: ["The NIC number must be 14 characters"],
          });
          showErrorsForInput([
            "The NIC number for joint life must be 14 characters",
          ]);
          return;
        }
        //End of Extra Frontend Validation

        //Term+ageNextBirthday Validation for main life
        if (!isValidAgeNextBirthdayWithTerm(state.birth, state.term_number)) {
          toast.error(
            "Sum of age next birthday for main life and term should not be more than 75!",
          );
          return;
        }

        //Term+ageNextBirthday Validation for joint life
        if (
          !isValidAgeNextBirthdayWithTerm(
            state.joint_user_birth,
            state.term_number,
          )
        ) {
          toast.error(
            "Sum of age next birthday for joint life and term should not be more than 75!",
          );
          return;
        }

        if (state.nic.length === 0 || state.nic.length !== 14) {
          toast.error("The NIC number must be 14 characters");
          return;
        }

        if (!isValidNic(state.nic, state.birth)) {
          toast.error(
            "The Main Life NIC number doesn't match with the birthday",
          );
          return;
        }

        if (
          state.joint_user_nic.length === 0 ||
          state.joint_user_nic.length !== 14
        ) {
          toast.error("The joint life NIC number must be 14 characters");
          return;
        }

        if (!isValidNic(state.joint_user_nic, state.joint_user_birth)) {
          toast.error(
            "The Joint Life NIC number doesn't match with the birthday",
          );
          return;
        }

        const payload = {
          ...state,
          userId: null,
          userJointId: null,
          main_user_name: state.firstname + " " + state.lastname,
          main_user_title: state.title,
          main_user_birth: state.birth,
          main_user_nic: state.nic,
          main_user_phoneNumber: state.phoneNumber,
          main_user_whatsappNumber: state.whatsappNumber,
          main_user_email: state.email,
          main_user_gender: state.gender,
          joint_user_title: state.joint_user_title,
          joint_user_name:
            state.joint_user_firstname + " " + state.joint_user_lastname,
          joint_user_birth: state.joint_user_birth,
          joint_user_nic: state.joint_user_nic,
          joint_user_gender: state.joint_user_gender,
          joint_user_phoneNumber: state.joint_user_phoneNumber,
          joint_user_whatsappNumber: state.joint_user_whatsappNumber,
          joint_user_email: state.joint_user_email,
          joint_user_maiden_name: state.maiden_name,
          joint_user_passport_number: state.passport_number,
          joint_user_nationality: state.nationality,
          joint_user_relationship: null,
          join_loan: true,
          savings_type: "regular",
          payment_insurance_plan: "monthly",
          initial_sum_assured: state.initial_sum_assured || 100000,
          basic_contribution_amount: 1000,
          single_contribution_amount: 50000,
          intended_commencement_date: getDate_ddmmyyyy(
            state.intended_commencement_date,
          ),
          branch_name: state.bank_branch_name,
          bank_branch_name: state.bank_branch_name,
          bank_rep_email: state.bank_rep_email,
          consent_bank_rep: true,
          death_benefit: 100000,
          tpd_benefit: 100000,
          beneficiaries: beneficiaries
            .filter((b) => b.fullname && parseFloat(b.percentage) > 0)
            .map((b) => ({
              fullname: b.fullname,
              percentage: parseFloat(b.percentage),
              nic: b.nic,
              relationship: b.relationship,
            })),
        };

        // change field keys
        payload.main_user_maiden_name = payload.maiden_name;
        payload.main_user_passport_number = payload.passport_number;
        payload.main_user_nationality = payload.nationality;

        delete payload.maiden_name;
        delete payload.passport_number;
        delete payload.nationality;

        if (!payload.userJointId) {
          payload.userJointId = null;
        }

        try {
          payload.initial_sum_assured = parseFloat(
            payload.initial_sum_assured.toString(),
          );
        } catch (error) {
          console.log(error);
        }
        // delete payload.gender;

        if (payload.bank_branch_name === "Other") {
          payload.bank_branch_name =
            payload.joint_user_financial_institution_branch;
          delete payload.joint_user_financial_institution_branch;
        }

        setLoading(true);
        setError(null);
        const { data } = await axiosPrivate.post(url, payload);

        setLoading(false);
        setErrors({});
        if (data.success) {
          navigate(
            `${process.env.REACT_APP_BASENAME}/quotations/${data.data.flexibleResult.id}`,
          );
        } else {
          toast.error(
            data.message
              ? data.message
              : "Quotation generation was unsuccessful, please try again",
          );
        }
      } catch (error) {
        //Handing Form Errors
        setLoading(false);
        toast.error(null);
        console.log(error);
        if (
          error?.response?.data?.errors &&
          error?.response?.data?.errors.length > 0
        ) {
          const errorsFromServer = error.response.data.errors;
          console.error(errorsFromServer);
          let errorData = {};
          if (Array.isArray(errorsFromServer)) {
            errorsFromServer.forEach((err) => {
              if (!errorData[err.field]) {
                errorData[err.field] = [];
              }
              //extra error handling
              errorData[err.field].push(err.message);
            });
          }
          setErrors(errorData);
        } else if (error?.response?.data?.message) {
          toast.error(error?.response?.data?.message);
        } else {
          toast.error(
            "Quotation generation was unsuccessful, please try again",
          );
        }
      }
    }
  };

  const getPartners = async () => {
    const url = process.env.REACT_APP_API_URL + `/worker/list/agents`;
    try {
      const response = await axiosPrivate.get(url);
      setAgents(response.data.data);
      setFilterSearch(response.data.data);
    } catch (e) {}
  };

  const handleSearchAgent = (event) => {
    const searchItem = event.target.value;
    setSearch(searchItem);

    if (searchItem === "") {
      setSelectedAgent(null);
      setFilterSearch(agents);
      return;
    }

    const searchResult = agents?.filter((ag) => {
      const fullName = `${ag?.title || ""} ${ag?.firstname || ""} ${
        ag?.lastname || ""
      }`;
      const searched = searchItem;

      return (
        fullName.includes(searched) ||
        ag?.newCode.includes(searched) ||
        ag?.firstname.includes(searched) ||
        ag?.lastname.includes(searched)
      );
    });

    setFilterSearch(searchResult || []);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenAgents(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getPartners();
  }, []);

  const [activeBenefit, setActiveBenefit] = useState(null);

  const handleAddBenefit = (id) => {
    if (
      id === 1 &&
      beneficiaries.some((b) => b.fullname && parseFloat(b.percentage) > 0)
    ) {
      setError("Cannot add bank details when beneficiaries exist");
      return;
    }

    if (id === 0 && (state.bank_name || state.bank_branch)) {
      setError("Cannot add beneficiaries when bank details exist");
      return;
    }

    setActiveBenefit((prev) => (prev === id ? null : id));
    setError(null);
  };

  const benefitsToggle = [
    {
      id: 0,
      title: "Beneficiary Details",
      icon: "/beneficiaryfamily.svg",
      content: "",
    },
    {
      id: 1,
      title: "Bank Details",
      icon: "/beneficiarybank.svg",
      content: "",
    },
  ];

  return (
    <>
      <Navbar
        name={userData ? userData?.data?.firstname?.split(" ")[0] : ""}
        branded={true}
      />

      <GoBack />

      <div className="tw-font-haas container px-lg-4">
        <div className="tw-space-y-0">
          <h1 className="mt-4 tw-font-semibold tw-text-lg">
            Create a New Insurance Quote
          </h1>
          <p className="">
            Generate a personalized insurance quote in just a few steps. Please
            provide accurate details to receive a tailored quotation.
          </p>
          <span className="text-danger tw-text-sm"> Required Fields *</span>
        </div>

        {localUserData?.data?.roles === "LA-HO" && (
          <section className="tw-w-full tw-py-4">
            <div className="tw-relative tw-z-20">
              <span className="tw-text-sm tw-text-black/50">
                Select Agent (Optional)
              </span>

              <label
                htmlFor="searchagent"
                className="tw-w-full"
                onClick={() => setOpenAgents(!openAgent)}
              >
                <input
                  id="searchagent"
                  type="text"
                  placeholder={
                    agents.length > 0 ? "Select Agent" : "Loading Agents..."
                  }
                  disabled={agents.length === 0}
                  value={search || ""}
                  onChange={handleSearchAgent}
                  // onFocus={() => setOpenAgents(true)}
                  className="tw-relative tw-w-full tw-h-12 tw-rounded-xl tw-border tw-border-black/30 !tw-bg-slate-100 tw-indent-4"
                />
                <span className="tw-absolute tw-right-3 tw-bottom-3">
                  <BiChevronDown size={24} />
                </span>
              </label>
              {openAgent && (
                <div
                  ref={dropdownRef}
                  className="tw-absolute tw-top-20 tw-bg-slate-50 tw-w-full tw-border tw-border-black/20 tw-h-[250px] tw-overflow-y-auto tw-rounded-lg tw-px-4"
                >
                  {filterSearch.length > 0 ? (
                    filterSearch.map((agent, index) => (
                      <div
                        key={index}
                        className="tw-py-2 hover:tw-bg-gray-200 tw-cursor-pointer"
                        onClick={() => {
                          setSearch(
                            `${agent?.title || ""} ${agent?.firstname || ""} ${
                              agent?.lastname || ""
                            }`,
                          );
                          setSelectedAgent(agent.id);
                          setOpenAgents(false);
                        }}
                      >
                        {agent?.title} {agent?.firstname} {agent?.lastname} -{" "}
                        {agent?.newCode}
                      </div>
                    ))
                  ) : (
                    <div className="tw-py-2 tw-text-gray-500">
                      {agents.length === 0 ? "Loading..." : "No agents found"}
                    </div>
                  )}
                </div>
              )}
            </div>
          </section>
        )}

        <div
          className="card border-0 bg-transparent"
          style={{
            borderRadius: 5,
          }}
        >
          <div className=" mt-5">
            <div className="mt-2">
              <div className="forms-sample">
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                {/* Personal Information */}
                <div className="mb-5">
                  <div className="form-group row mb-2">
                    <label htmlFor="title" className="col-sm-4  col-form-label">
                      <div>
                        <span className="tw-font-semibold ">
                          Personal Information
                        </span>
                        <p>Enter your personal details to get started</p>
                      </div>
                    </label>

                    <div className="col-sm-8 ">
                      {errors.title && (
                        <div className="invalid-feedback d-block">
                          {errors.title.map((message, index) => {
                            return <div key={index}>{message}</div>;
                          })}
                        </div>
                      )}
                      <div className="form-group row mb-3">
                        <label
                          htmlFor="title"
                          className="tw-text-black col-12 col-form-label ila-form-label"
                        >
                          Title <span className="text-danger">*</span>
                        </label>
                        <div className="col-12">
                          <div
                            className="form-check form-check-inline"
                            onClick={() => setState({ ...state, title: "Mr" })}
                          >
                            <input
                              readOnly
                              className="form-check-input"
                              type="radio"
                              name="mrRadio"
                              id="mrRadioNo"
                              checked={state.title === "Mr"}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="mrRadioNo"
                            >
                              Mr
                            </label>
                          </div>
                          <div
                            className="form-check form-check-inline"
                            onClick={() => setState({ ...state, title: "Ms" })}
                          >
                            <input
                              readOnly
                              className="form-check-input"
                              type="radio"
                              name="msLoanRadio"
                              id="msRadioYes"
                              checked={state.title === "Ms"}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="msRadioYes"
                            >
                              Ms
                            </label>
                          </div>
                          <div
                            className="form-check form-check-inline"
                            onClick={() => setState({ ...state, title: "Mrs" })}
                          >
                            <input
                              readOnly
                              className="form-check-input"
                              type="radio"
                              name="mrsRadio"
                              id="mrsRadioYes"
                              checked={state.title === "Mrs"}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="mrsRadioYes"
                            >
                              Mrs
                            </label>
                          </div>
                          <div
                            className="form-check form-check-inline"
                            onClick={() =>
                              setState({ ...state, title: "Miss" })
                            }
                          >
                            <input
                              readOnly
                              className="form-check-input"
                              type="radio"
                              name="missRadio"
                              id="missRadioYes"
                              checked={state.title === "Miss"}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="missRadioYes"
                            >
                              Miss
                            </label>
                          </div>
                          <div
                            className="form-check form-check-inline"
                            onClick={() => setState({ ...state, title: "Dr" })}
                          >
                            <input
                              readOnly
                              className="form-check-input"
                              type="radio"
                              name="drRadio"
                              id="drRadioYes"
                              checked={state.title === "Dr"}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="drRadioYes"
                            >
                              Dr
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-3">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-8 row">
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="firstname"
                          className=" col-form-label ila-form-label"
                        >
                          First Name <span className="text-danger">*</span>
                        </label>

                        <input
                          onChange={(event) => {
                            setState({
                              ...state,
                              firstname: event.target.value,
                            });
                          }}
                          value={state.firstname}
                          type="text"
                          className={`col-sm-12 input-control ${
                            errors.firstname && "is-invalid"
                          }`}
                          id="name"
                          placeholder="First Name"
                        />
                        {errors.firstname && (
                          <div className="invalid-feedback d-block">
                            {errors.firstname.map((message, index) => {
                              return <div key={index}>{message}</div>;
                            })}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="name"
                          className="col-sm-12  col-form-label ila-form-label"
                        >
                          Last Name <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-12 ">
                          <input
                            onChange={(event) => {
                              setState({
                                ...state,
                                lastname: event.target.value,
                              });
                            }}
                            value={state.lastname}
                            type="text"
                            className={`input-control ${
                              errors.lastname && "is-invalid"
                            }`}
                            id="name"
                            placeholder="Last Name"
                          />
                          {errors.lastname && (
                            <div className="invalid-feedback d-block">
                              {errors.lastname.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-3">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-8 row">
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="nic_date"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          Gender <span className="text-danger">*</span>
                        </label>

                        <div className="col-sm-12">
                          <select
                            onChange={(event) => {
                              setState({
                                ...state,
                                gender: event.target.value,
                              });
                            }}
                            value={state.gender}
                            className={`form-select ${
                              errors.gender && "is-invalid"
                            }`}
                            aria-label="Default select example"
                          >
                            <option value="">Select...</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                          </select>
                          {errors.gender && (
                            <div className="invalid-feedback d-block">
                              {errors.gender.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="nic_date"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          NIC (National Identity Card){" "}
                          <span className="text-danger">*</span>
                        </label>

                        <div className="col-sm-12">
                          <input
                            onChange={(event) => {
                              setState({
                                ...state,
                                nic: event.target.value,
                              });
                            }}
                            value={state.nic}
                            type="text"
                            className={`input-control ${
                              errors.nic && "is-invalid"
                            }`}
                            id="nic_date"
                            placeholder="NIC Number"
                          />
                          {errors.nic && (
                            <div className="invalid-feedback d-block">
                              {errors.nic.map((message, index) => {
                                return (
                                  <div key={index}>
                                    {message.replace("nic", "NIC")}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-3">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-8 row">
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="birth"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          Date of Birth <span className="text-danger">*</span>
                        </label>

                        <DatePicker
                          ref={birthRef}
                          dateFormat="dd/MM/yyyy"
                          placeholder="Date of Birth"
                          className={`date-control tw-pl-3 ${
                            errors.birth && "is-invalid"
                          }`}
                          selected={state.birth ? state.birth : null}
                          maxDate={new Date(eighteenYearsAgo)}
                          minDate={new Date(sixtyFiveYearsAgo)}
                          id="birth"
                          locale="uk"
                          onChange={(date) =>
                            setState({ ...state, birth: date })
                          }
                        />
                        {errors.birth && (
                          <div className="invalid-feedback d-block">
                            {errors.birth.map((message, index) => {
                              return <div key={index}>{message}</div>;
                            })}
                          </div>
                        )}
                      </div>

                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="email"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          Email <span className="text-danger">*</span>
                        </label>

                        <div className="col-sm-12">
                          <input
                            onChange={(event) => {
                              setState({ ...state, email: event.target.value });
                            }}
                            value={state.email}
                            type="text"
                            className={`input-control ${
                              errors.email && "is-invalid"
                            }`}
                            id="email"
                            placeholder="Email"
                          />
                          {errors.email && (
                            <div className="invalid-feedback d-block">
                              {errors.email.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-0">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-8 row">
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="phoneNumber"
                          className="tw-whitespace-nowrap col-sm-4 col-form-label ila-form-label"
                        >
                          Phone Number <span className="text-danger">*</span>
                        </label>
                        <div className="col-sm-12">
                          <CustomNumberInput
                            refVal={phoneNumberRef}
                            errors={errors}
                            setState={setState}
                            state={state}
                          />
                          {errors.phoneNumber && (
                            <div className="invalid-feedback d-inline-block">
                              {errors.phoneNumber.map((message, index) => {
                                return <div key={index}>{message}</div>;
                              })}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="col-12 col-lg-6 mb-3">
                        <label
                          htmlFor="phoneNumber"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          Whatsapp Number
                        </label>
                        <div className="col-sm-12">
                          <CustomNumberInput
                            placeholder={"Enter WhatsApp Number"}
                            refVal={whatsappNumberRef}
                            errors={errors}
                            state={state}
                            setState={setState}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*NEW FIELDS*/}
                  <div className="form-group row mb-3">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-8 row">
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="maiden_name"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          Maiden Name
                        </label>

                        <input
                          onChange={(event) => {
                            setState({
                              ...state,
                              maiden_name: event.target.value,
                            });
                          }}
                          value={state.maiden_name}
                          type="text"
                          className={`input-control ${
                            errors.maiden_name && "is-invalid"
                          }`}
                          id="maiden_name"
                          placeholder="Maiden Name"
                        />
                        {errors.maiden_name && (
                          <div className="invalid-feedback d-block">
                            {errors.maiden_name.map((message, index) => {
                              return <div key={index}>{message}</div>;
                            })}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="passport_number"
                          className="col-sm-12  col-form-label ila-form-label"
                        >
                          Passport Number{" "}
                        </label>

                        <input
                          onChange={(event) => {
                            setState({
                              ...state,
                              passport_number: event.target.value,
                            });
                          }}
                          value={state.passport_number}
                          type="text"
                          className={`input-control ${
                            errors.passport_number && "is-invalid"
                          }`}
                          id="passport_number"
                          placeholder="Passport Number"
                        />
                        {errors.passport_number && (
                          <div className="invalid-feedback d-block">
                            {errors.passport_number.map((message, index) => {
                              return <div key={index}>{message}</div>;
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="form-group row mb-3">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-8 row">
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="nationality"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          Nationality <span className="text-danger">*</span>
                        </label>

                        <input
                          onChange={(event) => {
                            setState({
                              ...state,
                              nationality: event.target.value,
                            });
                          }}
                          value={state.nationality}
                          type="text"
                          className={`input-control ${
                            errors.nationality && "is-invalid"
                          }`}
                          id="nationality"
                          placeholder="Nationality"
                        />
                        {errors.nationality && (
                          <div className="invalid-feedback d-block">
                            {errors.nationality.map((message, index) => {
                              return <div key={index}>{message}</div>;
                            })}
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-lg-6">
                        <label
                          htmlFor="name"
                          className="col-sm-12  col-form-label ila-form-label"
                        >
                          Joint Policy <span className="text-danger">*</span>
                        </label>

                        <div className="col-sm-12">
                          <div
                            className="form-check form-check-inline"
                            onClick={() =>
                              setState({ ...state, join_loan: false })
                            }
                          >
                            <input
                              readOnly
                              className="form-check-input"
                              type="radio"
                              name="joinLoanRadio"
                              id="joinLoanRadioNo1"
                              checked={!state.join_loan}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="joinLoanRadioNo1"
                            >
                              No
                            </label>
                          </div>
                          <div
                            className="form-check form-check-inline"
                            onClick={() =>
                              setState({ ...state, join_loan: true })
                            }
                          >
                            <input
                              readOnly
                              className="form-check-input"
                              type="radio"
                              name="joinLoanRadio"
                              id="joinLoanRadioYes1"
                              checked={state.join_loan}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="joinLoanRadioYes1"
                            >
                              Yes
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* NEW FIELDS */}
                </div>
                {/* End Personal Information */}

                {state.join_loan && (
                  <>
                    {/* Joint Life Information */}
                    <section className="tw-py-8">
                      <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                    </section>
                    <div className="my-5">
                      <div className="form-group row mb-3">
                        <label
                          htmlFor="title"
                          className="col-sm-4 col-form-label"
                        >
                          <div>
                            <h1 className="tw-font-semibold tw-text-lg">
                              Joint Life Information
                            </h1>
                            <p>Enter details to set up your Joint Life.</p>
                          </div>
                        </label>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="firstname"
                              className="col-sm-12  col-form-label ila-form-label"
                            >
                              Phone Number for Joint Life{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <CustomNumberInput
                                refVal={jointLifephoneNumberRef}
                                errors={{}}
                                state={state}
                                setState={setState}
                                fieldName="joint_user_phoneNumber"
                              />
                            </div>
                          </div>

                          <div className="align-items-end col-12 col-lg-6 d-flex">
                            <button
                              onClick={validateJointLife}
                              style={{ color: "#BEC663", outline: "none" }}
                              className="btn btn-white border-0 fw-bold shadow-none text-decoration-none"
                            >
                              {validatingJointLife && (
                                <span className="spinner-border-sm spinner-border me-2"></span>
                              )}
                              Validate
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-0">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 ">
                          <div className="form-group row mb-3">
                            <label
                              htmlFor="title"
                              className="col-12  col-form-label ila-form-label"
                            >
                              Title for Joint Life{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="col-12">
                              <div
                                className="form-check form-check-inline"
                                onClick={() =>
                                  !jointLifeFieldsDisabled &&
                                  setState({ ...state, joint_user_title: "Mr" })
                                }
                              >
                                <input
                                  readOnly
                                  className="form-check-input"
                                  type="radio"
                                  disabled={jointLifeFieldsDisabled}
                                  name="mrRadioJointLife"
                                  id="mrRadioJointLife"
                                  checked={state.joint_user_title === "Mr"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="mrRadioJointLife"
                                >
                                  Mr
                                </label>
                              </div>
                              <div
                                className="form-check form-check-inline"
                                onClick={() =>
                                  !jointLifeFieldsDisabled &&
                                  setState({ ...state, joint_user_title: "Ms" })
                                }
                              >
                                <input
                                  readOnly
                                  className="form-check-input"
                                  type="radio"
                                  disabled={jointLifeFieldsDisabled}
                                  name="msLoanRadioJointLife"
                                  id="msLoanRadioJointLife"
                                  checked={state.joint_user_title === "Ms"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="msLoanRadioJointLife"
                                >
                                  Ms
                                </label>
                              </div>
                              <div
                                className="form-check form-check-inline"
                                onClick={() =>
                                  !jointLifeFieldsDisabled &&
                                  setState({
                                    ...state,
                                    joint_user_title: "Mrs",
                                  })
                                }
                              >
                                <input
                                  readOnly
                                  className="form-check-input"
                                  type="radio"
                                  disabled={jointLifeFieldsDisabled}
                                  name="mrsRadioJointLife"
                                  id="mrsRadioJointLife"
                                  checked={state.joint_user_title === "Mrs"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="mrsRadioJointLife"
                                >
                                  Mrs
                                </label>
                              </div>
                              <div
                                className="form-check form-check-inline"
                                onClick={() =>
                                  !jointLifeFieldsDisabled &&
                                  setState({
                                    ...state,
                                    joint_user_title: "Miss",
                                  })
                                }
                              >
                                <input
                                  readOnly
                                  className="form-check-input"
                                  type="radio"
                                  disabled={jointLifeFieldsDisabled}
                                  name="missRadioJointLife"
                                  id="missRadioJointLife"
                                  checked={state.joint_user_title === "Miss"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="missRadioJointLife"
                                >
                                  Miss
                                </label>
                              </div>
                              <div
                                className="form-check form-check-inline"
                                onClick={() =>
                                  !jointLifeFieldsDisabled &&
                                  setState({ ...state, joint_user_title: "Dr" })
                                }
                              >
                                <input
                                  readOnly
                                  className="form-check-input"
                                  type="radio"
                                  disabled={jointLifeFieldsDisabled}
                                  name="drRadioJointLife"
                                  id="drRadioJointLife"
                                  checked={state.joint_user_title === "Dr"}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="drRadioJointLife"
                                >
                                  Dr
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="joint_user_firstname"
                              className="col-sm-12  col-form-label ila-form-label"
                            >
                              First Name <span className="text-danger">*</span>
                            </label>

                            <input
                              disabled={jointLifeFieldsDisabled}
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  joint_user_firstname: event.target.value,
                                });
                              }}
                              value={state.joint_user_firstname}
                              type="text"
                              className={`input-control ${
                                errors.joint_user_firstname && "is-invalid"
                              }`}
                              id="name"
                              placeholder="First Names"
                            />
                            {errors.joint_user_firstname && (
                              <div className="invalid-feedback d-block">
                                {errors.joint_user_firstname.map(
                                  (message, index) => {
                                    return <div key={index}>{message}</div>;
                                  },
                                )}
                              </div>
                            )}
                          </div>

                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="joint_user_lastname"
                              className="col-sm-12  col-form-label ila-form-label"
                            >
                              Last name <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-12 ">
                              <input
                                disabled={jointLifeFieldsDisabled}
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_lastname: event.target.value,
                                  });
                                }}
                                value={state.joint_user_lastname}
                                type="text"
                                className={`input-control ${
                                  errors.joint_user_lastname && "is-invalid"
                                }`}
                                id="name"
                                placeholder="Last Name"
                              />
                              {errors.joint_user_lastname && (
                                <div className="invalid-feedback d-block">
                                  {errors.joint_user_lastname.map(
                                    (message, index) => {
                                      return <div key={index}>{message}</div>;
                                    },
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="joint_user_birth"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Date of Birth{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <DatePicker
                                disabled={jointLifeFieldsDisabled}
                                ref={otherBirthRef}
                                dateFormat="dd/MM/yyyy"
                                className={`input-control ${
                                  errors.joint_user_birth && "is-invalid"
                                }`}
                                selected={
                                  state.joint_user_birth
                                    ? state.joint_user_birth
                                    : null
                                }
                                maxDate={new Date(eighteenYearsAgo)}
                                minDate={new Date(sixtyFiveYearsAgo)}
                                id="joint_user_birth"
                                locale="uk"
                                onChange={(date) =>
                                  setState({ ...state, joint_user_birth: date })
                                }
                              />
                              {errors.birth && (
                                <div className="invalid-feedback d-block">
                                  {errors.birth.map((message, index) => {
                                    return <div key={index}>{message}</div>;
                                  })}
                                </div>
                              )}
                            </div>
                          </div>

                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="name"
                              className="col-sm-12  col-form-label ila-form-label"
                            >
                              NIC <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <input
                                disabled={jointLifeFieldsDisabled}
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_nic: event.target.value,
                                  });
                                }}
                                value={state.joint_user_nic}
                                type="text"
                                className={`input-control ${
                                  errors.joint_user_nic && "is-invalid"
                                }`}
                                id="nic_date"
                                placeholder="National Identity Card Number"
                              />
                              {errors.joint_user_nic && (
                                <div className="invalid-feedback d-block">
                                  {errors.joint_user_nic.map(
                                    (message, index) => {
                                      return (
                                        <div key={index}>
                                          {message.replace("nic_date", "NIC")}
                                        </div>
                                      );
                                    },
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="email"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Email for Joint Life{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <input
                                disabled={jointLifeFieldsDisabled}
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_email: event.target.value,
                                  });
                                }}
                                value={state.joint_user_email}
                                type="text"
                                className={`input-control ${
                                  errors.name && "is-invalid"
                                }`}
                                id="name"
                                placeholder="Email for Joint Life"
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="gender"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Gender <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <select
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_gender: event.target.value,
                                  });
                                }}
                                disabled={jointLifeFieldsDisabled}
                                value={state.joint_user_gender}
                                className={`form-select ${
                                  errors.joint_user_gender && "is-invalid"
                                }`}
                                aria-label="Default select example"
                              >
                                <option value="">Select...</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                              </select>
                              {errors.joint_user_gender && (
                                <div className="invalid-feedback d-block">
                                  {errors.joint_user_gender.map(
                                    (message, index) => {
                                      return <div key={index}>{message}</div>;
                                    },
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="joint_user_maiden_name"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Maiden Name
                            </label>

                            <div className="col-sm-12">
                              <input
                                disabled={jointLifeFieldsDisabled}
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_maiden_name: event.target.value,
                                  });
                                }}
                                value={state.joint_user_maiden_name}
                                type="text"
                                className={`input-control ${
                                  errors.joint_user_maiden_name && "is-invalid"
                                }`}
                                id="joint_user_maiden_name"
                                placeholder="Joint User Maiden Name"
                              />
                            </div>
                          </div>
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="joint_user_passport_number"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Passport Number{" "}
                            </label>

                            <div className="col-sm-12">
                              <input
                                disabled={jointLifeFieldsDisabled}
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_passport_number:
                                      event.target.value,
                                  });
                                }}
                                value={state.joint_user_passport_number}
                                type="text"
                                className={`input-control ${
                                  errors.joint_user_passport_number &&
                                  "is-invalid"
                                }`}
                                id="joint_user_passport_number"
                                placeholder="Joint User Passport Number"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="form-group row mb-3">
                        <div className="col-sm-4"></div>
                        <div className="col-sm-8 row">
                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="joint_user_nationality"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Nationality <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <input
                                disabled={jointLifeFieldsDisabled}
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_nationality: event.target.value,
                                  });
                                }}
                                value={state.joint_user_nationality}
                                type="text"
                                className={`input-control ${
                                  errors.joint_user_nationality && "is-invalid"
                                }`}
                                id="joint_user_nationality"
                                placeholder="Joint User Nationality"
                              />
                            </div>
                          </div>

                          <div className="col-12 col-lg-6">
                            <label
                              htmlFor="joint_user_relationship"
                              className="col-sm-12 col-form-label ila-form-label"
                            >
                              Relationship{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="col-sm-12">
                              <input
                                disabled={jointLifeFieldsDisabled}
                                onChange={(event) => {
                                  setState({
                                    ...state,
                                    joint_user_relationship: event.target.value,
                                  });
                                }}
                                value={state.joint_user_relationship}
                                type="text"
                                className={`input-control ${
                                  errors.joint_user_relationship && "is-invalid"
                                }`}
                                id="joint_user_relationship"
                                placeholder="Joint User Relationship"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* End Joint Life */}
                  </>
                )}

                {/* Add Beneficiary */}
                <section className="tw-py-8">
                  <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                </section>

                <div className="my-5">
                  <div className="form-group row mb-3">
                    <label htmlFor="title" className="col-sm-4 col-form-label">
                      <div>
                        <span className="tw-font-semibold">
                          Beneficiary Or Bank Details
                        </span>
                        <p>
                          Select either Bank or Beneficiary details to complete
                          your policy setup.
                        </p>
                      </div>
                    </label>
                    <div className="col-sm-8 tw-space-y-4">
                      <div className="col-12 col-lg-7">
                        <label
                          htmlFor="firstname"
                          className="col-sm-12 col-form-label ila-form-label"
                        >
                          Intended Commencement Date{" "}
                          <span className="text-danger">*</span>
                        </label>

                        <div className="col-sm-12">
                          <DatePicker
                            ref={intendedCommencementDateRef}
                            dateFormat="dd/MM/yyyy"
                            className={`input-control ${
                              errors.intended_commencement_date && "is-invalid"
                            }`}
                            selected={
                              state.intended_commencement_date
                                ? state.intended_commencement_date
                                : null
                            }
                            maxDate={new Date(fifteenDaysFromToday)}
                            minDate={new Date(today)}
                            id="intended_commencement_date"
                            locale="uk"
                            onChange={(date) =>
                              setState({
                                ...state,
                                intended_commencement_date: date,
                              })
                            }
                          />
                          {errors.intended_commencement_date && (
                            <div className="invalid-feedback d-block">
                              {errors.intended_commencement_date.map(
                                (message, index) => {
                                  return <div key={index}>{message}</div>;
                                },
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="tw-flex tw-flex-col lg:tw-flex-row tw-grow tw-flex-wrap tw-items-start md:tw-items-center tw-gap-2">
                        {benefitsToggle.map((tog) => {
                          const hasBankData =
                            state.initial_sum_assured ||
                            state.bank_name ||
                            state.bank_branch ||
                            state.joint_user_financial_institution_branch ||
                            state.bank_rep_name ||
                            state.bank_rep_email ||
                            state.bank_rep_contact;

                          const hasBeneficiaryData = beneficiaries.some(
                            (b) =>
                              b.fullname ||
                              b.percentage ||
                              b.nic ||
                              b.relationship,
                          );

                          const isDisabled =
                            (tog.id === 0 && hasBankData) ||
                            (tog.id === 1 && hasBeneficiaryData);

                          return (
                            <div
                              key={tog.id}
                              onClick={() =>
                                !isDisabled && handleAddBenefit(tog.id)
                              }
                              className={`tw-bg-transparent tw-rounded-lg tw-w-fit tw-h-[3.2rem] tw-px-4 tw-border tw-border-black/20 tw-flex tw-items-center tw-gap-2 ${
                                activeBenefit === tog.id
                                  ? "!tw-bg-[#BEC663]/10 tw-cursor-pointer"
                                  : isDisabled
                                    ? "tw-cursor-not-allowed tw-opacity-50"
                                    : "tw-cursor-pointer"
                              }`}
                            >
                              <IoCheckmark
                                className={`tw-bg-transparent tw-rounded-full tw-w-5 tw-h-5 tw-p-1 tw-text-white ${
                                  activeBenefit === tog.id
                                    ? "!tw-bg-[#BEC663]"
                                    : isDisabled
                                      ? "tw-border tw-border-black/50 tw-opacity-50"
                                      : "tw-border tw-border-black/50"
                                }`}
                              />
                              <img
                                className="tw-w-[30px] tw-object-contain"
                                alt={tog.title}
                                src={tog.icon}
                              />
                              <span
                                className={isDisabled ? "tw-opacity-50" : ""}
                              >
                                {tog.title}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {activeBenefit === 0 && (
                  <>
                    <section className="tw-py-8">
                      <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                    </section>
                    <section className="form-group row mb-3">
                      <label
                        htmlFor="title"
                        className="col-sm-4 col-form-label"
                      >
                        <div>
                          <span className="tw-font-semibold">
                            Add Beneficiary
                          </span>
                          <p>
                            Enter beneficiary details and assign their
                            percentage.
                          </p>
                        </div>
                      </label>

                      <div className="tw-w-full col-sm-8 row">
                        <div className="col-sm-4"></div>
                        {beneficiaries.map((beneficiary, index) => (
                          <div
                            key={index}
                            className={` ${index > 0 && "mb-4"} `}
                          >
                            <div className={` ${index > 0 && "tw-py-6"} `}>
                              <div
                                className={` ${
                                  index > 0 ? "tw-flex" : "tw-hidden"
                                } tw-border-b tw-w-full tw-border-black/10`}
                              ></div>
                            </div>
                            <span className="tw-bg-[#BEC663] tw-rounded-full tw-w-10 tw-h-10 tw-p-2 tw-text-white tw-grid tw-place-items-center">
                              {index + 1}
                            </span>
                            <div className="row">
                              <div className="col-sm-8 row"></div>
                              <div className="col-12 col-lg-6">
                                <label className="col-sm-12 col-form-label ila-form-label">
                                  Beneficiary Full Name
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`input-control ${
                                    beneficiaryErrors[index]?.fullname &&
                                    "is-invalid"
                                  }`}
                                  value={beneficiary.fullname}
                                  onChange={(e) =>
                                    handleBeneficiaryChange(
                                      index,
                                      "fullname",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Full Name"
                                  // disabled={
                                  //   parseFloat(beneficiary.percentage) === 0
                                  // }
                                />
                                {beneficiaryErrors[index]?.fullname && (
                                  <div className="invalid-feedback">
                                    {beneficiaryErrors[index].fullname}
                                  </div>
                                )}
                              </div>

                              <div className="col-12 col-lg-6">
                                <label className="col-sm-12 col-form-label ila-form-label">
                                  Percentage Allocation
                                  <span className="text-danger">*</span>
                                </label>
                                <div className="input-group">
                                  <input
                                    type="number"
                                    className={`input-control ${
                                      beneficiaryErrors[index]?.percentage &&
                                      "is-invalid"
                                    }`}
                                    value={beneficiary.percentage}
                                    onChange={(e) =>
                                      handleBeneficiaryChange(
                                        index,
                                        "percentage",
                                        e.target.value,
                                      )
                                    }
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                    step="1"
                                  />
                                  {/* <span className="input-group-text">%</span> */}
                                  {beneficiaryErrors[index]?.percentage && (
                                    <div className="invalid-feedback">
                                      {beneficiaryErrors[index].percentage}
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-12 col-lg-6">
                                <label className="col-sm-12 col-form-label ila-form-label">
                                  NIC (National Identity Card)
                                </label>
                                <input
                                  type="text"
                                  className={`input-control ${
                                    beneficiaryErrors[index]?.nic &&
                                    "is-invalid"
                                  }`}
                                  value={beneficiary.nic}
                                  onChange={(e) =>
                                    handleBeneficiaryChange(
                                      index,
                                      "nic",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="NIC"
                                  disabled={
                                    parseFloat(beneficiary.percentage) === 0
                                  }
                                />
                                {beneficiaryErrors[index]?.nic && (
                                  <div className="invalid-feedback">
                                    {beneficiaryErrors[index].nic}
                                  </div>
                                )}
                              </div>
                              <div className="col-12 col-lg-6">
                                <label className="col-sm-12 col-form-label ila-form-label">
                                  Relationship
                                  <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`input-control ${
                                    beneficiaryErrors[index]?.relationship &&
                                    "is-invalid"
                                  }`}
                                  value={beneficiary.relationship}
                                  onChange={(e) =>
                                    handleBeneficiaryChange(
                                      index,
                                      "relationship",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Relationship"
                                  disabled={
                                    parseFloat(beneficiary.percentage) === 0
                                  }
                                />
                                {beneficiaryErrors[index]?.relationship && (
                                  <div className="invalid-feedback">
                                    {beneficiaryErrors[index].relationship}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="tw-my-4">
                              <div className="tw-flex tw-flex-end tw-justify-self-end">
                                <button
                                  type="button"
                                  className="tw-bg-transaprent tw-border tw-border-[#BEC663] tw-rounded-md tw-w-fit tw-h-10 tw-px-3 tw-text-[#BEC663] tw-font-semibold tw-text-sm"
                                  onClick={() => removeBeneficiary(index)}
                                >
                                  {beneficiaries.length === 1
                                    ? "Clear"
                                    : "Remove"}
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}

                        <div className="tw-w-full mb-3">
                          <div className="!tw-bg-[#CFF4FC] tw-w-full tw-h-auto tw-rounded-lg tw-p-4 tw-text-[#135C6B]">
                            <span className="tw-font-semibold">
                              Total Allocation:
                            </span>{" "}
                            {totalAllocated}%
                            {totalAllocated !== 100 && (
                              <span>
                                {" "}
                                - Please distribute 100% among beneficiaries
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="tw-w-full tw-flex tw-justify-end">
                          <button
                            type="button"
                            className={` ${
                              totalAllocated >= 100
                                ? " tw-py-2 tw-px-4 tw-w-auto tw-h-auto tw-rounded-lg tw-cursor-not-allowed"
                                : ""
                            } tw-whitespace-nowrap tw-flex tw-items-center tw-gap-x-2 tw-bg-[#BEC663]/10 tw-border tw-border-[#BEC663] tw-text-black/50 tw-p-3 tw-rounded-md`}
                            onClick={addBeneficiary}
                            disabled={totalAllocated >= 100}
                          >
                            <PlusIcon className="tw-bg-[#BEC663] tw-text-white tw-rounded-full tw-w-4 tw-h-4" />
                            <span>Add New Beneficiary</span>
                          </button>
                        </div>
                      </div>
                    </section>
                  </>
                )}

                {/* End Add Beneficiary */}

                {/* IFSP Specifications */}
                {activeBenefit === 1 && (
                  <div className="my-5">
                    <section className="tw-py-8">
                      <div className="tw-border-b tw-w-full tw-border-black/10"></div>
                    </section>
                    <div className="form-group row mb-3">
                      <label
                        htmlFor="title"
                        className="col-sm-4  col-form-label"
                      >
                        <div>
                          <span className="tw-font-semibold">
                            Enter Bank Details
                          </span>
                          <p>
                            Provide your bank information for the policy payout.
                          </p>
                        </div>
                      </label>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="sum-assured"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Sum Assured <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <CurrencyInput
                              className={`input-control ${
                                errors.initial_sum_assured && "is-invalid"
                              }`}
                              onValueChange={(event) => {
                                setState({
                                  ...state,
                                  initial_sum_assured: event,
                                });
                              }}
                              prefix="Rs "
                              value={state.initial_sum_assured}
                              placeholder="Sum Assured"
                            />

                            {errors.initial_sum_assured && (
                              <div className="invalid-feedback d-block">
                                {errors.initial_sum_assured.map(
                                  (message, index) => {
                                    return <div key={index}>{message}</div>;
                                  },
                                )}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="firstname"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Financial Institution{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <select
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  bank_name: event.target.value,
                                });
                                setBankBranches(
                                  getBranchesForBank(event.target.value),
                                );
                              }}
                              value={state.bank_name}
                              className={`form-select ${
                                errors.bank_name && "is-invalid"
                              }`}
                              aria-label="Default select example"
                            >
                              <option value="">Select...</option>
                              {banks &&
                                banks.map((bank, index) => {
                                  return (
                                    <option value={bank.name} key={index}>
                                      {bank.name}
                                    </option>
                                  );
                                })}
                            </select>
                            {errors.bank_name && (
                              <div className="invalid-feedback d-block">
                                {errors.bank_name.map((message, index) => {
                                  return <div key={index}>{message}</div>;
                                })}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="name"
                            className="col-sm-12  col-form-label ila-form-label"
                          >
                            Financial Institution Branch{" "}
                            <span className="text-danger">*</span>
                          </label>

                          <div className="col-sm-12">
                            <select
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  bank_branch_name: event.target.value,
                                });
                              }}
                              value={state.bank_branch_name}
                              className={`form-select ${
                                errors.bank_branch_name && "is-invalid"
                              }`}
                              aria-label="Default select example"
                            >
                              <option value="">Select...</option>
                              {banks && (
                                <>
                                  {bankBranches.map((branch, index) => {
                                    return (
                                      <option
                                        value={branch.name + "-" + branch.town}
                                        key={index}
                                      >
                                        <div>
                                          <div>
                                            {branch.name} - {branch.town}
                                          </div>
                                        </div>
                                      </option>
                                    );
                                  })}
                                </>
                              )}
                              <option value="Other">Other</option>
                            </select>

                            {state.bank_branch_name === "Other" && (
                              <div className="form-group row mb-3">
                                <label
                                  htmlFor="joint_user_financial_institution_branch"
                                  className="col-sm-12 mt-2 col-form-label"
                                >
                                  Please Specify Branch{" "}
                                </label>
                                <div className="col-sm-12 ">
                                  <input
                                    onChange={(event) => {
                                      setState({
                                        ...state,
                                        joint_user_financial_institution_branch:
                                          event.target.value,
                                      });
                                    }}
                                    value={
                                      state.joint_user_financial_institution_branch
                                    }
                                    type="text"
                                    className={`input-control `}
                                    id="joint_user_financial_institution_branch"
                                    placeholder="Financial Institution Branch"
                                  />
                                </div>
                              </div>
                            )}

                            {errors.bank_branch_name && (
                              <div className="invalid-feedback d-block">
                                {errors.bank_branch_name.map(
                                  (message, index) => {
                                    return <div key={index}>{message}</div>;
                                  },
                                )}
                              </div>
                            )}

                            {errors.bank_branch && (
                              <div className="invalid-feedback d-block">
                                {errors.bank_branch.map((message, index) => {
                                  return <div key={index}>{message}</div>;
                                })}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="bank_rep_name"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Bank Representative Name
                          </label>

                          <div className="col-sm-12">
                            <input
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  bank_rep_name: event.target.value,
                                });
                              }}
                              value={state.bank_rep_name}
                              type="text"
                              className={`input-control `}
                              id="bank_rep_name"
                              placeholder="Bank Rep Name"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Insert bank rep details */}
                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="name"
                            className="col-sm-12  col-form-label ila-form-label"
                          >
                            Bank Representative Email
                          </label>

                          <div className="col-sm-12">
                            <input
                              onChange={(event) => {
                                setState({
                                  ...state,
                                  bank_rep_email: event.target.value,
                                });
                              }}
                              value={state.bank_rep_email}
                              type="text"
                              className={`input-control `}
                              id="bank_rep_email"
                              placeholder="Bank Rep Email"
                            />
                          </div>
                        </div>

                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="name"
                            className="tw-text-black/50 col-sm-12"
                          >
                            Do you consent to ILA sending your Policy Documents
                            to your designated Bank Representative?
                          </label>

                          <div className="col-sm-12">
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, consent_bank_rep: false })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="bankRepConsentRadio"
                                id="bankRepConsentRadioNo"
                                checked={!state.consent_bank_rep}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="bankRepConsentRadioNo"
                              >
                                No
                              </label>
                            </div>
                            <div
                              className="form-check form-check-inline"
                              onClick={() =>
                                setState({ ...state, consent_bank_rep: true })
                              }
                            >
                              <input
                                readOnly
                                className="form-check-input"
                                type="radio"
                                name="bankRepConsentRadio"
                                id="bankRepConsentRadioYes"
                                checked={state.consent_bank_rep}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="bankRepConsentRadioYes"
                              >
                                Yes
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group row mb-3">
                      <div className="col-sm-4"></div>
                      <div className="col-sm-8 row">
                        <div className="col-12 col-lg-6">
                          <label
                            htmlFor="bank_rep_name"
                            className="col-sm-12 col-form-label ila-form-label"
                          >
                            Bank Representative Contact
                          </label>

                          <div className="col-sm-12">
                            <CustomNumberInput
                              refVal={bankRepContactRef}
                              errors={{}}
                              state={state}
                              setState={setState}
                              fieldName="bank_rep_contact"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="tw-w-full tw-flex tw-justify-end tw-mt-4">
                      <button
                        type="button"
                        onClick={clearBankDetails}
                        className="tw-bg-transparent tw-border tw-border-[#BEC663] tw-rounded-md tw-w-fit tw-h-10 tw-px-3 tw-text-[#BEC663] tw-font-semibold tw-text-sm"
                      >
                        Clear Bank Details
                      </button>
                    </div>
                  </div>
                )}

                {/* End IFSP Specifications */}

                <div className="d-flex justify-content-end">
                  <button
                    onClick={() => {
                      submitData();
                    }}
                    type="button"
                    className="btn submit-btn me-2 mb-3"
                    disabled={loading}
                  >
                    {loading && (
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    )}{" "}
                    Create Quotation
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FlexiSingleQuotationAuthenticated;
